
// @ts-nocheck
import React, { Fragment, Component } from 'react'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'

import { Logo } from './Logo'
import { SearchContainer } from './Search'
import { CartContainer } from './Cart'
import { UserProfileContainer } from './UserProfile'
import { TrackingContainer } from './Tracking'
import { WishlistContainer } from './Wishlist'

import HeaderWrapper from './HeaderWrapper'
import { MainMenuContainer } from '../MainMenu'
import { UserBasicInformation } from './UserBasicInformation'
import TitleAnnouncer from '../Shell/TitleAnnouncer'
import MobileMenuLogged from '../Footer/MobileMenuLogged'

import { connect } from 'react-redux'

class DefaultHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sendGTM: false
    }
  }

  sendGTM () {
    setTimeout(() => {
      if (!this.state.sendGTM) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'global',
          'dimension1': this.props.participant_Id,
          'dimension6': this.props.campaing_Id,
          'dimension7': process.env.REACT_APP_CATALOG_ID,
          'dimension8': process.env.SKIN
        })
        this.setState({ sendGTM: true })
      }
    }, 500)
  }

  componentDidMount () {
    if (!this.state.sendGTM) {
      this.sendGTM(this.props)
    }

    document.querySelectorAll('#meu-negocio').length > 0 && document.querySelector('#meu-negocio').focus()
  }

  render () {
    return (
      <Fragment>
        <HeaderWrapper>
          <MediaQuery maxDeviceWidth={1024}>
            <TitleAnnouncer orientation='mobile' />
          </MediaQuery>
          <MediaQuery minDeviceWidth={1025}>
            <TitleAnnouncer orientation='desktop' />
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <MobileMenuLogged />
          </MediaQuery>
          <Logo />
          <MediaQuery minWidth={768}>
            <SearchContainer />
            <UserProfileContainer />
          </MediaQuery>
          { process.env.REACT_APP_HAS_WISHLIST_HEADER && <WishlistContainer />}
          <TrackingContainer />
          <CartContainer desktop />
          <MediaQuery maxWidth={767}>
            <SearchContainer />
          </MediaQuery>

        </HeaderWrapper>
        <MediaQuery maxWidth={767}>
          <UserBasicInformation {...this.state} />
        </MediaQuery>
        <MediaQuery minWidth={768}>
          <MainMenuContainer {...this.state} />
        </MediaQuery>
      </Fragment>
    )
  }
}
DefaultHeader.propTypes = {
  refererIsLogin: PropTypes.bool,
  campaing_Id: PropTypes.string,
  participant_Id: PropTypes.string
}
const mapStateToProps = ({ oidc }) => {
  return ({
    campaing_Id: oidc.user.profile['custom:campaign_id'],
    participant_Id: oidc.user.profile['custom:participant_id']
  })
}
export default connect(mapStateToProps)(DefaultHeader)



// WEBPACK FOOTER //
// ./src/App/Header/DefaultHeader.js